export default {
  PAY_NOW: 'PAYMENT_CATEGORY_PAY_NOW',
  PAY_LATER: 'PAYMENT_CATEGORY_PAY_LATER',
};
